import { forwardRef, type Ref, type SVGProps } from "react";
const IconPanoramaOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path fill="currentColor" d="M9 12a2 2 0 1 0 0 4 2 2 0 1 0 0-4" />
    <path
      fill="currentColor"
      d="M29 6h-.15A88 88 0 0 1 16 7.09 88 88 0 0 1 3.15 6H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h.15A88 88 0 0 1 16 24.91 88 88 0 0 1 28.85 26H29a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1M4 8.2a90 90 0 0 0 12 .93 90 90 0 0 0 12-.93v8.4l-2.29-2.34a1 1 0 0 0-1.42 0L21 17.61l-2.29-2.33a1 1 0 0 0-1.42 0l-7.75 7.89c-2.22.19-4.17.44-5.54.63zm12 14.67c-1.15 0-2.3 0-3.43.09L18 17.44l3.29 3.35a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.44l-.3-.3L25 16.42l3 3.06v4.32a90 90 0 0 0-12-.93"
    />
  </svg>
);
const ForwardRef = forwardRef(IconPanoramaOutlineSVG);
ForwardRef.displayName = "IconPanoramaOutline";
export { ForwardRef as IconPanoramaOutline };
